import { makeStyles } from '@material-ui/core/styles'
import { useParams } from 'react-router-dom'
import { isEmpty } from 'lodash'
import { useAttributes } from 'hooks/customerAttributes'
import { DraggableList, Loader, EmptyState } from 'components'

import Group from './group/Group'
import AddAttribute from './add-attribute/AddAtribute'

const CustomerAttributes = () => {
  const { projectId } = useParams();
  const { isFetching: isLoading, attributes } = useAttributes(projectId)
  const classes = useStyles()

  if (isLoading) {
    return <Loader size={100}/>
  }

  if (isEmpty(attributes)) {
    return (
      <>
        <EmptyState />
        <AddAttribute isEmpty />
      </>
    )
  }

  return (
    <>
      <DraggableList items={attributes}>
        {({ ref, item, snapshotProps, ...rest }) => (
          <div className={classes.item} ref={ref} {...rest}>
            <Group item={item} isDragging={snapshotProps.isDragging} />
          </div>
        )}
      </DraggableList>
      <AddAttribute />
    </>
  )
}

const useStyles = makeStyles(() => ({
  item: {
    marginBottom: '20px',
  },
}))

CustomerAttributes.propTypes = {}

CustomerAttributes.defaultProps = {}

export default CustomerAttributes
